/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
/** Common Components */
import FormCreator from "../../../components/finalForms/FormCreator"
import Buttons from "../../../components/ui/button/Buttons"
import { AppIcons } from "../../../data/appIcons";
import ToastService from "../../../services/toastService/ToastService";
import { mapDropdownOptions } from "../../../components/finalForms/libs/mapDropdownOptions";
import FinalMolGrid from "../../../components/FinalMolGrid/FinalMolGrid";
import SwalAlert from "../../../services/swalService/SwalService";
/** Common Services & Data Files */
import { assignUserFormData, assignUserGridConfig } from "./config/AssignUser.data";
import {
  useAddRoleMappingMutation,
  useDeleteRolesMappingMutation,
  useGetRolesMappingByRoleIdMutation,
  useLazyGetUnAssignedUserByRoleIdQuery
} from "../../../app/services/RoleManagement";

const AssignUser = ({ roleId, isOpen, onSidebarClose }) => {
  const userRef = useRef();
  const molGridRef = useRef();
  const { confirm } = SwalAlert();
  /* State*/
  const [formData] = useState(assignUserFormData);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [listData, setListData] = useState();
  const [shouldRerenderFormCreator, setShouldRerenderFormCreator] = useState(false);
  /** RTK Query */
  const [addRoleMapping, {
    isLoading: isAddRoleMappingLoading,
    isSuccess: isUserAddRoleMapping,
    data: AddRoleMappingData
  }] = useAddRoleMappingMutation();
  const [getUnAssignedUserByRoleId, {
    isFetching: isGetUnAssignedUserByRoleIdFetching,
    isSuccess: isGetUnAssignedUserByRoleId,
    data: GetUnAssignedUserByRoleIdData
  }] = useLazyGetUnAssignedUserByRoleIdQuery();
  const [getRolesMappingByRoleId, {
    isLoading: isListLoading,
    isSuccess: isListSuccess,
    data: isListeData
  }] = useGetRolesMappingByRoleIdMutation();
  const [deleteRolesMapping, {
    isSuccess: isDeleteSuccess,
    data: isDeletData
  }] = useDeleteRolesMappingMutation();

  //** useEffect's */
  useEffect(() => {
    if (isOpen && roleId) {
      getUnAssignedUserByRoleId(roleId);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isGetUnAssignedUserByRoleIdFetching && isGetUnAssignedUserByRoleId && GetUnAssignedUserByRoleIdData) {
      mapDropdownOptions(assignUserFormData, 'AssignUser', 'userId', GetUnAssignedUserByRoleIdData, 'userId', 'userName');
      setShouldRerenderFormCreator((prevState) => !prevState);
    }
  }, [isGetUnAssignedUserByRoleIdFetching, isGetUnAssignedUserByRoleId, GetUnAssignedUserByRoleIdData]);

  useEffect(() => {
    if (molGridRef.current) {
      const defaultPageObject = molGridRef.current.getCurrentPageObject();
      getLists(defaultPageObject, molGridRef.current.generateSortingString());
    }
  }, [isOpen]);

  useEffect(() => {
    if (isListSuccess && isListeData) {

      if (isListeData) {
        setListData(isListeData.dataSource);
      }
      if (isListeData.totalRecord) {
        setTotalRowCount(isListeData.totalRecord);
      }
    }
  }, [isListSuccess, isListeData]);

  useEffect(() => {
    if (isUserAddRoleMapping && AddRoleMappingData) {
      ToastService.success(AddRoleMappingData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getLists(currentPageObject, molGridRef.current.generateSortingString());
      getUnAssignedUserByRoleId(roleId);
    }
  }, [isUserAddRoleMapping, AddRoleMappingData]);

  useEffect(() => {
    if (isDeleteSuccess && isDeletData) {
      ToastService.success(isDeletData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getLists(currentPageObject, molGridRef.current.generateSortingString());
      getUnAssignedUserByRoleId(roleId);

    }
  }, [isDeleteSuccess, isDeletData]);

  //** Funcation's */
  const handlePageChange = (page) => {
    getLists(page, molGridRef.current.generateSortingString());
  };

  const handleSorting = (shortString) => {
    getLists(molGridRef.current.getCurrentPageObject(), shortString);
  };
  const getLists = (pageObject, sortingString) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pageNumber,
        pageSize: pageObject.pageSize,
      },
      filters: { searchText: "" },
      roleId: roleId,
      sortString: sortingString,
    };
    getRolesMappingByRoleId(request);
  };

  const handleUser = () => {
    let userData = userRef.current.getFormData();
    if (userData && roleId) {

      let req = {
        userId: userData.userId.value,
        roleId: roleId,
      };
      addRoleMapping(req);
    }
  };

  const handleDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteRolesMapping(data.userRoleId);
      }
    });
  };
  const actionHandler = {
    DELETE: handleDeleteClick,
  };


  return (<>
    <FormCreator
      ref={userRef}
      config={formData}  {...formData}
      key={shouldRerenderFormCreator}
    />
    <div className="form-btn d-flex justify-content-end">
      <Buttons
        buttonTypeClassName="dark-btn"
        onClick={onSidebarClose}
        buttonText="Cancel"
      />
      <Buttons
        buttonTypeClassName="theme-btn ml-4"
        buttonText="Assign User"
        onClick={handleUser}
        imagePath={AppIcons.AddIcon}
        isLoading={isAddRoleMappingLoading}
      />

    </div>
    <div className="table-grid mt-2">
      <FinalMolGrid
        ref={molGridRef}
        configuration={assignUserGridConfig}
        dataSource={listData}
        allowPagination={true}
        pagination={{
          totalCount: totalRowCount,
          pageSize: 10,
          currentPage: 1,
        }}
        isLoading={isListLoading}
        onActionChange={actionHandler}
        onPageChange={handlePageChange}
        onSorting={handleSorting}
      />

    </div>
  </>
  )
}
export default AssignUser